module.exports = __webpack_public_path__ + "static/media/brown-merrell.f96ef0a3.jpg";